var L = /^image-([\da-f]+)-(\d+x\d+)-(\w+)$/,
  y = i => {
    let t = L.exec(i),
      [, e, o, r] = t ?? [];
    if (!t || !e || !o || !r) throw new Error(`Could not parse image ID "${i}"`);
    let [a, d] = o.split("x").map(p => Number.parseInt(p, 10));
    if (Number.isNaN(a) || Number.isNaN(d) || !a || !d) throw new Error(`Invalid dimensions "${o}"`);
    return {
      assetId: e,
      dimensions: {
        height: d,
        width: a,
        aspectRatio: a / d
      },
      format: r
    };
  },
  N = i => {
    let t = i.lastIndexOf("-");
    return i.slice(6, t) + "." + i.slice(t + 1);
  },
  I = ({
    baseUrl: i,
    ...t
  }) => {
    let {
      metadata: e,
      ...o
    } = S({
      ...t,
      options: {
        includeMetadata: !0
      }
    });
    if (!e) throw new Error("Missing image output metadata");
    return {
      src: `${`${i}${N(t.id)}`}?${C(o)}`,
      width: e.outputDimensions.width,
      height: e.outputDimensions.height
    };
  },
  M = ({
    id: i,
    mode: t = "contain",
    width: e,
    height: o,
    hotspot: r,
    crop: a,
    baseUrl: d,
    ...p
  }) => {
    let {
        w: h,
        h: m
      } = S({
        id: i,
        mode: t,
        width: e,
        height: o,
        hotspot: r,
        crop: a
      }),
      l = `${d}${N(i)}`,
      u = z(h).map(s => {
        let n = Math.round(h * s),
          f = m && Math.round(m * s);
        if (s < 1 && n < 50) return null;
        let g = S({
          id: i,
          mode: t,
          width: n,
          height: f,
          hotspot: r,
          crop: a,
          ...p
        });
        return `${l}?${C(g)} ${g.w}w`;
      }).filter(s => !!s);
    return Array.from(new Set(u));
  },
  D = ({
    id: i,
    baseUrl: t
  }) => {
    let {
      assetId: e,
      dimensions: o,
      format: r
    } = y(i);
    return {
      src: `${t}${e}-${o.width}x${o.height}.${r}`,
      width: o.width,
      height: o.height
    };
  },
  z = i => i < 160 ? [.5, 1, 2] : i < 750 ? [.5, 1, 1.5, 2] : i < 1400 ? [.25, .5, .75, 1, 1.5, 2] : [.25, .5, .75, 1, 1.25, 1.5, 1.75, 2],
  S = ({
    id: i,
    mode: t = "contain",
    width: e,
    height: o,
    hotspot: r,
    crop: a,
    queryParams: d,
    options: {
      includeMetadata: p = !1
    } = {}
  }) => {
    let h = y(i).dimensions,
      {
        width: m,
        height: l,
        aspectRatio: u
      } = a ? A(h, a) : h;
    if (e || (o ? (e = Math.round(o * u), o = void 0) : e = Math.round(m / 2)), t === "cover" && (!e || !o || e / o === u) ? t = "contain" : t === "contain" && o && (e = Math.min(e, Math.round(o * u)), o = void 0), e > m || o && o > l) {
      let n = o ? e / o : u;
      n >= u ? (e = m, o = o && Math.round(e / n)) : (o = l, e = Math.round(o * n));
    }
    let s = {
      w: e,
      q: 75,
      fit: "max",
      ...d
    };
    if (s.fm || (s.auto = "format"), a && (s.rect = O(h, a)), t === "cover") if (s.fit = "crop", o && (s.h = o), r) {
      let n = a ? (r.x - a.left) / (1 - a.left - a.right) : r.x,
        f = a ? (r.y - a.top) / (1 - a.top - a.bottom) : r.y;
      s["fp-x"] = E(R(n, 0, 1), 3), s["fp-y"] = E(R(f, 0, 1), 3);
    } else s.crop = "entropy";
    if (p) {
      let n = o ?? Math.round(e / u);
      s.metadata = {
        sourceDimensions: h,
        outputDimensions: {
          width: e,
          height: n,
          aspectRatio: e / n
        }
      };
    }
    return s;
  },
  R = (i, t, e) => Math.max(t, Math.min(e, i)),
  E = (i, t) => Math.round(i * Math.pow(10, t)) / Math.pow(10, t),
  A = (i, t) => {
    if (t.left + t.right >= 1 || t.top + t.bottom >= 1) throw new Error(`Invalid crop: ${JSON.stringify(t)}; crop values must be less than 1`);
    let e = Math.round(i.width * (1 - t.left - t.right)),
      o = Math.round(i.height * (1 - t.top - t.bottom)),
      r = e / o;
    return {
      width: e,
      height: o,
      aspectRatio: r
    };
  },
  O = (i, t) => {
    let {
      width: e,
      height: o
    } = A(i, t);
    return [Math.round(t.left * i.width), Math.round(t.top * i.height), e, o].join(",");
  },
  C = i => new URLSearchParams(Object.entries(i).sort(([t], [e]) => t.localeCompare(e)).map(([t, e]) => [t, String(e)])).toString().replace(/%2C/g, ","),
  T = i => "_id" in i ? i._id : i._ref,
  k = i => {
    let {
      _ref: t,
      ...e
    } = i;
    return {
      ...e,
      _id: T(i)
    };
  };
import { useEffect as H, useRef as j, useState as J } from "react";
import { Fragment as U, jsx as W, jsxs as B } from "react/jsx-runtime";
var b = ({
    as: i,
    preview: t,
    style: e,
    alt: o,
    ...r
  }) => {
    let [a, d] = J(!1),
      p = j(null),
      h = () => {
        d(!0);
      };
    H(() => {
      p.current?.complete && h();
    }, []);
    let m = i ?? "img";
    return B(U, {
      children: [!a && W(m, {
        src: t,
        alt: a ? "" : o,
        id: r.id,
        className: r.className,
        width: r.width,
        height: r.height,
        style: {
          aspectRatio: `${r.width} / ${r.height}`,
          ...e
        },
        "data-lqip": !0
      }), W(m, {
        "data-loading": a ? null : !0,
        alt: a ? o : "",
        onLoad: h,
        ref: p,
        style: a ? e : {
          ...Q,
          ...e
        },
        ...r
      })]
    });
  },
  Q = {
    height: "10px",
    width: "10px",
    position: "absolute",
    zIndex: -10,
    opacity: 0,
    pointerEvents: "none",
    userSelect: "none"
  };
import { jsx as _ } from "react/jsx-runtime";
var F = ({
  as: i,
  baseUrl: t,
  projectId: e,
  dataset: o,
  id: r,
  hotspot: a,
  crop: d,
  width: p,
  height: h,
  mode: m = "contain",
  preview: l,
  htmlWidth: u,
  htmlHeight: s,
  htmlId: n,
  queryParams: f,
  ...g
}) => {
  if (!r) throw new Error("Missing required `id` prop for <SanityImage>.");
  if (!t && (!e || !o)) throw new Error("Missing required `baseUrl` or `projectId` and `dataset` props for <SanityImage>.");
  t = t ?? `https://cdn.sanity.io/images/${e}/${o}/`;
  let $ = r.endsWith("-svg"),
    x = l && !$ ? b : i ?? "img",
    c = {
      alt: g.alt ?? "",
      loading: g.loading ?? "lazy",
      id: n,
      ...g
    };
  if ($) {
    let w = D({
      id: r,
      baseUrl: t
    });
    return i === "source" && (w.srcSet = w.src, delete w.src), _(x, {
      ...w,
      ...c
    });
  }
  let v = {
      baseUrl: t,
      id: r,
      crop: d,
      hotspot: a,
      width: p,
      height: h,
      mode: m,
      queryParams: f
    },
    {
      src: q,
      ...P
    } = I(v);
  return c.srcSet = M(v).join(", "), c.src = q, c.width = u ?? P.width, c.height = s ?? P.height, l && (c.as = i ?? "img", c.preview = l), _(x, {
    ...c
  });
};
export { b as ImageWithPreview, F as SanityImage, T as assetId, I as buildSrc, M as buildSrcSet, k as normalizeAssetId, y as parseImageId };